import bold from '../bold';
import emojiFont from './emoji';

const fontFamily = {
    EXP_NEUE_ITALIC: 'ExpensifyNeue-Italic',
    EXP_NEUE_BOLD: bold,
    EXP_NEUE: 'ExpensifyNeue-Regular',
    EXP_NEW_KANSAS_MEDIUM: 'ExpensifyNewKansas-Medium',
    EXP_NEW_KANSAS_MEDIUM_ITALIC: 'ExpensifyNewKansas-MediumItalic',
    SYSTEM: 'System',
    MONOSPACE: 'ExpensifyMono-Regular',
    MONOSPACE_ITALIC: 'ExpensifyMono-Regular',
    MONOSPACE_BOLD: 'ExpensifyMono-Bold',
    MONOSPACE_BOLD_ITALIC: 'ExpensifyMono-Bold',
    EMOJI_TEXT_FONT: emojiFont,
};

export default fontFamily;
